import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import modules from "./modules";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      paths: ["auth"],
    }),
  ],
  strict: process.env.NODE_ENV !== "production",
});

export default store;


// Automatically run the `init` action,
store.dispatch(`auth/init`);
